import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Popover, Spin } from "antd";
import { numberformatter } from "$ACTIONS/util";
import { bonusActions } from "$STORE/bonusSlice";

const WalletBalanceHeader = () => {
    const balanceInfo = useSelector((state) => state.balance.balanceInfo);
    const isBalanceLoading = useSelector(
        (state) => state.balance.isBalanceLoading
    );
    const dispatch = useDispatch();

    const {
        isWithdrawalContractBalanceBlocking = false,
        withdrawableBalance = 0,
        totalBalance = 0,
        totalContractBalance = 0,
    } = balanceInfo || {};

    const handleArrowClick = () => {
        Pushgtagdata(
            "Withdrawal",
            "Go to Locked Balance",
            "Withdrawal_C_LockedBalance"
        );
        dispatch(bonusActions.setLockedBalanceVisible(true));
    };

    const renderBalanceInfo = () => {
        const title = isWithdrawalContractBalanceBlocking
            ? "ยอดเงินที่ถอนได้" //可提款金额
            : "ยอดเงินรวม"; //总余额
        const balance = isWithdrawalContractBalanceBlocking
            ? withdrawableBalance
            : totalBalance;

        return (
            <div className="withdrawal-info-box">
                <div className="withdrawal-title">{title}</div>
                <div className={`withdrawal-balance${isWithdrawalContractBalanceBlocking ? " add-spacing": ""}`}>
                    ฿ {numberformatter(balance, 2, "removeWhenDecimalAllZero")}
                </div>
            </div>
        );
    };

    const renderTurnoverInfo = () => (
        <div className="turnover-info">
            {/* 未完成流水金额 */}
            <span className="turnover-text">ยอดหมุนเวียนที่ยังไม่ครบ</span>
            {/* 完成流水要求，以解锁符合条件的存款和优惠金额至可提款金额 */}
            <Popover
                placement="bottomLeft"
                align={{ offset: [-12, 5] }}
                content={
                    <>
                        ทำยอดหมุนเวียนให้ครบตามที่กำหนดเพื่อ
                        <br />
                        ปลดล็อกยอดเงินฝากและโบนัส
                        <br />
                        เพื่อสามารถทำการถอนออกได้
                    </>
                }
                overlayStyle={{ maxWidth: "252px" }}
            >
                <img src="/th/img/icon/lock.svg" alt="lock" className="lock" />
            </Popover>
            <div className="turnover-balance-container">
                <span className="turnover-amount">
                    ฿ {numberformatter(totalContractBalance, 2, "removeWhenDecimalAllZero")}
                </span>
                <img
                    src="/th/img/icon/gray-arrow.svg"
                    alt="arrow"
                    className="right-arrow"
                    onClick={handleArrowClick}
                />
            </div>
        </div>
    );

    return (
        <Spin spinning={isBalanceLoading}>
            <div className="withdrawal-info-container">
                {renderBalanceInfo()}
                {isWithdrawalContractBalanceBlocking && (
                    <>
                        {/* (提款流水将在注单结算后的 15 分钟内更新) */}
                        <div className="withdrawal-update-info">
                            (ยอดหมุนเวียนการถอนจะอัปเดตภายใน 15 นาที
                            หลังจากการเดิมพันได้รับการตัดสิน)
                        </div>
                        {renderTurnoverInfo()}
                    </>
                )}
            </div>
        </Spin>
    );
};

export default WalletBalanceHeader;
